import React from "react";
import { useLocation,useNavigate } from "react-router-dom";
import Axios from "axios";
import { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
 import 'react-toastify/dist/ReactToastify.css';
 import { VerifyEmailAPIURL } from "../apiconstants/constants";
const AiVerifyemail = () => {
    const search = useLocation().search;
const token=new URLSearchParams(search).get("token");

const apiUrl=VerifyEmailAPIURL.APIURL;
const navigate=useNavigate();
const APICall = () => {
 const fliterdata = { token: token };  
     Axios.post(apiUrl, fliterdata)  
     .then((result) => {
    if (result.data.message === 'Token is not exist')  
       toast.error('Please provide a valid token.', {autoClose:5000})
       else   
       toast.success('Registration successful, now you can login into Hire Me', {autoClose:5000})
       navigate("/AIResumeInsights");       
     }).catch(
       function (error) {
         console.log("Error"+error)
       }) 
     
     return new Promise(resolve => {
       setTimeout(() => {
           resolve();
       }, 5000);
   });

 }  

 useEffect(() => {
  // Run! Like go get some data from an API.
  APICall()
}, []);

    return ( 
   
 
   <div className="container" style={{heght:700}}>
    <div className="row">
      <div className="col-12" >

   
    

      </div>

    </div>
    <ToastContainer />
   </div>
   

     );
}
 
export default AiVerifyemail;